// extracted by mini-css-extract-plugin
export var button = "_ft-4";
export var hasDarkBackground = "_ft-7";
export var hasLightBackground = "_ft-6";
export var iconWrapper = "_ft-0";
export var large = "_ft-2";
export var medium = "_ft-1";
export var small = "_ft-5";
export var xsmall = "_ft-3";